module.exports = __webpack_public_path__ + "static/img/8.8470d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/8.png
// module id = xpoK
// module chunks = 35